export const dashboardStyles = {
  activityChartIcon: {
    marginTop: "-5px",
  },
};
